/**
 * Botão de tema claro/escuro do website
 */

import { Moon, Sun } from 'lucide-react';
import { useSiteTheme } from '../useSiteTheme';

export function SiteThemeToggle({ className = '' }: { className?: string }) {
  const { theme, toggleTheme } = useSiteTheme();
  const isDark = theme === 'dark';
  // Rótulo fixo + aria-pressed: o leitor de tela anuncia "Tema claro, ativado/desativado"
  // (rótulo variável junto com aria-pressed se contradiria)
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Tema claro"
      title={isDark ? 'Ativar tema claro' : 'Voltar ao tema escuro'}
      aria-pressed={!isDark}
      data-testid="site-theme-toggle"
      className={`flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 text-slate-300 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-400 ${className}`}
    >
      {isDark ? <Sun size={18} aria-hidden /> : <Moon size={18} aria-hidden />}
    </button>
  );
}
